<script>
import PickupNotes from '@/views/Application/CustomerService/Pickups/Pickup/Notes'

export default {
  extends: PickupNotes,
  data () {
    return {
      breadcrumb: {
        name: 'Notes',
        route: { name: 'customerservice-accounts-account-pickups-pickup-notes', params: this.$route.params }
      }
    }
  }
}
</script>
